module.exports = __webpack_public_path__ + "static/media/loanClousre_Selected.269cf793.svg";